import React from 'react';
import './button.scss';
import classNames from 'classnames';

const Button = (props) => {

	let className = classNames(
		'component',
		'button',
		(props.icon ? '-with-icon' : '-without-icon'),
		{ [`-icon-${props.icon}`]: props.icon },
		(props.iconinline ? '-icon-inline' : ''),
		(props.text ? '-with-text' : '-without-text'),
		props.className
	)

	let handleClick = () => {
		if(props.clickEvent) window.dispatchEvent(new CustomEvent(props.clickEvent, {detail : props.fields }))
	}

	return 	<button onClick={() => handleClick()} className={className}>
				{props.text && props.text}
			</button>
}

export default Button;


// WEBPACK FOOTER //
// ./src/components/button/button.jsx